import React, { ClipboardEvent, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Image,
  Input,
  ListItem,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Text,
  UnorderedList
} from '@chakra-ui/react';
import { DealerProfileType } from '@masterffl/dealer-profile-component';
import AriaSelectDropdown from '@/common/AriaSelectDropdown';
import { businessPhoneLabels } from '@/utils/constants';
import CustomRadio from '@/common/CustomRadio';
import { CustomAddress } from '@/explore/types';
import ControlledInput from '@/common/ControllerInput';
import {
  callToCreateDealerAction,
  setIsCreateDealerActionCompleted,
  setIsCreateDealerActionInprogress
} from '@/explore/ducks/slice';
import { useDispatch } from 'react-redux';
import {
  getEmailErrorState,
  getIsCreateDealerActionCompleted,
  getIsCreateDealerActionInprogress,
  getBouncedEmailError
} from '@/explore/ducks/selectors';
//@ts-ignore
import InputMask from 'react-input-mask';
import { getIsGlobalAdmin } from '@/redux/app-selectors';

interface StoreContactDetailsEditProps {
  iscontactDetailsEditOpen: boolean;
  oncontactDetailsEditClose: () => void;
  dealerDetail?: DealerProfileType;
  dealerId: string;
}

interface ContactType {
  value: string | null;
  title?: string | null;
  isPrimary: boolean;
  isAtf?: boolean;
  label?: string | null;
  errors?: string;
  allowAsValidEmail?: boolean;
  bounced?: string | null;
  
}
interface ShippingAddressOptionType {
  CUSTOM?: string;
  MAILING?: string;
  PREMISE?: string;
}
interface CustomAddressType {
  type?: string;
  address?: {
    id?: number;
    city: string;
    state: string;
    street: string;
    zipCode: string;
    errors?: {
      street?: string;
      city?: string;
      state?: string;
      zipCode?: string;
    };
  };
  isPrimary?: boolean;
}

interface InputFieldType {
  allowAsValidEmail?: boolean;
  license_key: string | null;
  name: string;
  type: string;
  value?: string | null;
  title?: string | null;
  label?: string | null;
}

interface ErrorType {
  [key: string]: { [index: number]: string | null };
}

const validateContactNumbers = (
  existingNumbers: ContactType[],
  newNumbers: ContactType[]
): { [key: number]: string } => {
  const errors: { [key: number]: string } = {};
  const allNumbers = [...existingNumbers, ...newNumbers];
  const seenNumbers = new Map<string, number[]>();

  // Collect all numbers and their indices
  newNumbers.forEach((phone, index) => {
    if (!phone.value) {
      errors[index] = 'Contact number is required';
      return;
    }

    const cleanedValue = phone.value.replace(/\D/g, '');
    
    // Validate length
    if (cleanedValue.length !== 10) {
      errors[index] = 'Please enter a valid contact number';
      return;
    }

    // Track duplicates
    if (!seenNumbers.has(cleanedValue)) {
      seenNumbers.set(cleanedValue, []);
    }
    seenNumbers.get(cleanedValue)!.push(index);
  });

  // Check for duplicates with existing numbers
  newNumbers.forEach((phone, index) => {
    if (errors[index]) return; // Skip if already has an error

    const cleanedValue = phone.value?.replace(/\D/g, '') || '';
    
    const existsInOriginal = existingNumbers.some((existing) => {
      const existingCleaned = existing.value?.replace(/\D/g, '') || '';
      return existingCleaned === cleanedValue && cleanedValue !== '';
    });

    if (existsInOriginal) {
      errors[index] = 'Contact number already added';
    }
  });

  // Mark duplicates within new numbers
  seenNumbers.forEach((indices, number) => {
    if (indices.length > 1 && number !== '') {
      // Mark all occurrences after the first as duplicates
      indices.slice(1).forEach(idx => {
        if (!errors[idx]) {
          errors[idx] = 'Contact number already added';
        }
      });
    }
  });

  return errors;
};

const StoreContactDetailsEdit = ({
  iscontactDetailsEditOpen,
  oncontactDetailsEditClose,
  dealerDetail,
  dealerId
}: StoreContactDetailsEditProps) => {
  console.log({ StoreContactDetailsEdit: dealerDetail });
  const dispatch = useDispatch();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
   const isGlobalAdmin = getIsGlobalAdmin();
  const [contactName, setContactName] = useState<ContactType[]>([]);
  const [contactNumber, setContactNumber] = useState<ContactType[]>([]);
  const [contactEmail, setContactEmail] = useState<ContactType[]>([]);
  const [contactWebsite, setContactWebsite] = useState<ContactType[]>([]);
  const [addContactName, setAddContactName] = useState<any[]>([]);
  const [addContactNumber, setAddContactNumber] = useState<ContactType[]>([]);
  const [addContactEmail, setAddContactEmail] = useState<ContactType[]>([]);
  const [addContactWebsite, setAddContactWebsite] = useState<ContactType[]>([]);
  const [contactAddresses, setContactAddresses] = useState<CustomAddressType[]>(
    []
  );
  const [shippingAddressOptions, setShippingAddressOptions] = useState<any>(
    {}
  );
  const [shippingAddressSelecValue, setShippingAddressSelecValue] =
    useState<string>('');
  const [defaultShippingAddress, setDefaultShippingAddress] =
    useState<string>('');
  const [addLabel, setAddLabel] = useState<InputFieldType[]>([]);
  const [customAddress, setCustomAddress] = useState<CustomAddressType>({});
  const [inputField, setInputField] = useState<InputFieldType[]>([]);
  const [deletedField, setDeletedField] = useState<InputFieldType[]>([]);
  const [isPrimaryField, setIsPrimaryField] = useState<InputFieldType[]>([]);
  const [removeCustom, setRemoveCustom] = useState(false);
  const [customAddressExist, setCustomAddressExist] = useState(false);
  const [claimedData, setClaimedData] = useState<any>({});
  const [errors, setErrors] = useState<ErrorType>({});
  const [activeTab, setActiveTab] = useState<'contact' | 'claim'>('contact');
  const [showChangeOwner, setShowChangeOwner] = useState(false);
  const [newOwnerEmail, setNewOwnerEmail] = useState('');
  const [isInvalidEmail, setIsInvalidEmail] = useState(false);
  const [showUnclaimConfirm, setShowUnclaimConfirm] = useState(false);
const [isUnclaimProfile, setIsUnclaimProfile] = useState(false);
    const [radioValue, setRadioValue] = useState("existing");
    const [selectedExistingEmail, setSelectedExistingEmail] = useState('');
const [confirmNewOwnerEmail, setConfirmNewOwnerEmail] = useState('');
const [copied, setCopied] = useState(false);
  const [showBackendErrors, setShowBackendErrors] = useState({
    phone: false,
    email: false
  });
  const emailBackendError = getEmailErrorState();
  const bouncedEmailError =getBouncedEmailError();
  useEffect(() => {
    if (dealerDetail) {
      console.log({
        contactNameFormatted: dealerDetail.businessDetails.contactNames
      });
      setContactName(dealerDetail.businessDetails.contactNames || []);
      const phones = dealerDetail?.businessDetails?.phones?.filter((phone) => phone?.value) || []
      setContactNumber(phones);
      setContactEmail(dealerDetail.businessDetails.emails || []);
      setContactAddresses(dealerDetail?.businessDetails?.address || []);
      setContactWebsite(dealerDetail.businessDetails.websites || []);
      setClaimedData(dealerDetail.myffl)
    }
  }, [dealerDetail]);
  console.log({ shippingAddressSelecValue });
  const hasEmails = contactEmail && contactEmail.length > 0;

const formattedDate = new Date(claimedData?.createdAt).toLocaleDateString('en-US', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric'
});

const validateEmail = (email:any) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

 const handleCopy = () => {
    navigator.clipboard.writeText(claimedData.email);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 1500);
  };


const radioStyle = {
    '.chakra-radio__control': {
      width: '22px',
      height: '22px',
      border: '3px solid #9E9E9E',
      borderRadius: '50%',
      bg: 'white',
    },

    '.chakra-radio__control[data-checked]': {
      borderColor: '#9E9E9E',
      bg: 'white',
    },

    '.chakra-radio__control[data-checked]::before': {
      content: '""',
      width: '14px',
      height: '14px',
      borderRadius: '50%',
      bg: '#18336E',
    }
  };

  const handleDuplicateError = (
    name: string,
    arr: ContactType[],
    value: string,
    message: string
  ) => {
    let index = 0;
    const isDuplicate = false;
    let count = 0;
    console.log({ asfdsfds: arr });
    arr.map((row, index) => {
      if (row.value === value) {
        count = count + 1;
        index = index;
        console.log('found same value at index', index);
      }
      const existingError = handleGetError(name, index);
      console.log('resetting values', existingError, name, index);
      handleSetErrors(name, index, null);
      if (!existingError?.includes('already added')) {
        const message = existingError;
        handleSetErrors(name, index - 1, message);
      }
    });

    if (count > 1) {
      handleSetErrors(name, index, message);
    }
  };

  const getBackendValidationError = (name: 'email' | 'phone') => {
    return emailBackendError.filter((row) => row.errorField === name); 
    console.log({ emailBackendError });
    // const errors = JSON.parse(emailBackendError);
  };
  const resetEmailErrors = (arr: ContactType[]) => {
    let count = 0;
    let duplicateIndex = 0;
    console.log('duplicate arr', arr);

    //resetting erros
    setErrors((curr) => ({
      ...curr,
      email: {}
    }));
    arr.map((row, index) => {
      const isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        row.value?.toString() as string
      );
      if (!isValid) {
        handleSetErrors('email', index, 'Please enter a valid email');
        return;
      }

      arr.map((secondRow, secondIndex) => {
        if (row.value === secondRow.value && index !== secondIndex) {
          count = count + 1;
          duplicateIndex = index > secondIndex ? index : secondIndex;
          console.log(
            'duplicate found',
            row,
            secondRow,
            index,
            secondIndex,
            duplicateIndex,
            count
          );
        }
      });
    });

    if (count > 1) {
      handleSetErrors('email', duplicateIndex, 'Email already added');
    }
  };

  const resetContactNumberErrors = (arr: ContactType[]) => {
    let count = 0;
    let duplicateIndex = 0;

    //resetting erros
    setErrors((curr) => ({
      ...curr,
      phone: {}
    }));
    arr.map((row, index) => {
      const mobile = row?.value?.replaceAll('-', '');
      const isValid = /^\d{10}$/.test(mobile?.toString() as string);
      console.log('is number value', isValid, row.value?.length, index);
      if (!isValid) {
        handleSetErrors('phone', index, 'Please enter a valid contact number');
        return;
      }

      arr.map((secondRow, secondIndex) => {
        if (row.value === secondRow.value && index !== secondIndex) {
          console.log('duplicate found', row, secondRow, index, count);
          count = count + 1;
          duplicateIndex = index;
        }
      });
    });

    if (count > 1) {
      handleSetErrors('phone', duplicateIndex, 'Contact number already added');
    }
  };

  const resetWebsiteErrors = (arr: ContactType[]) => {
    let count = 0;
    let duplicateIndex = 0;
    console.log('validating array errors', arr);

    //resetting erros
    setErrors((curr) => ({
      ...curr,
      website: {}
    }));
    arr.map((row, index) => {
      const isValid =
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(
          row?.value?.toString() as string
        );
      if (!isValid) {
        handleSetErrors('website', index, 'Please enter a valid website');
        return;
      }

      arr.map((secondRow, secondIndex) => {
        if (row.value === secondRow.value && index !== secondIndex) {
          console.log('duplicate found', row, secondRow, index, count);
          count = count + 1;
          duplicateIndex = index;
        }
      });
    });

    if (count > 1) {
      handleSetErrors('website', duplicateIndex, 'Website already added');
    }
  };

  const resetContactNameErrors = (arr: ContactType[]) => {
    let count = 0;
    let duplicateIndex = 0;

    //resetting erros
    setErrors((curr) => ({
      ...curr,
      contact_names_title: {}
    }));
    arr.map((row, index) => {
      arr.map((secondRow, secondIndex) => {
        if (row.value === secondRow.value && index !== secondIndex) {
          console.log('duplicate found', row, secondRow, index, count);
          count = count + 1;
          duplicateIndex = index;
        }
      });
    });

    if (count > 1) {
      handleSetErrors(
        'contact_names_title',
        duplicateIndex,
        'Contact Name already added'
      );
    }
  };

  console.log({ errors });

  const findPrimaryAddressType = (addresses: any[]): string => {
    const primaryAddress = addresses.find(
      (address) => address.isPrimary === true
    );

    if (primaryAddress) {
      switch (primaryAddress.type) {
        case 'custom':
          return 'CUSTOM';
        case 'premise':
          return 'PREMISE';
        case 'mailing':
          return 'MAILING';
      }
    }
    return '';
  };

  console.log({
    isCreateDealerActionInprogress,
    isCreateDealerActionCompleted
  });

  
  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted) {
      oncontactDetailsEditClose();
      setAddContactName([]);
      setAddContactNumber([]);
      setAddContactEmail([]);
      setAddContactWebsite([]);
      setContactAddresses([]);
      dispatch(setIsCreateDealerActionCompleted(false));
    }
  }, [isCreateDealerActionInprogress, isCreateDealerActionCompleted]);

  useEffect(() => {
    if (contactAddresses) {
      const primaryAddress = findPrimaryAddressType(contactAddresses);
      setDefaultShippingAddress(primaryAddress);
      setShippingAddressSelecValue(primaryAddress);
      const addressPremiseObject = contactAddresses.find(
        (address) => address.type === 'premise'
      );
      const premiseAddress = addressPremiseObject
        ? addressPremiseObject.address
        : null;
      if (premiseAddress) {
        setShippingAddressOptions(
          (prevShippingAddressOptions: ShippingAddressOptionType[]) => ({
            ...prevShippingAddressOptions,
            ...{
              PREMISE: `${premiseAddress.street}, ${premiseAddress.city}, ${premiseAddress.state}, ${premiseAddress.zipCode}`
            }
          })
        );
      }
      const addressMailingObject = contactAddresses.find(
        (address) => address.type === 'mailing'
      );
      const mailAddress = addressMailingObject
        ? addressMailingObject.address
        : null;
      if (mailAddress) {
        setShippingAddressOptions(
          (prevShippingAddressOptions: ShippingAddressOptionType[]) => ({
            ...prevShippingAddressOptions,
            ...{
              MAILING: `${mailAddress.street}, ${mailAddress.city}, ${mailAddress.state}, ${mailAddress.zipCode}`
            }
          })
        );
      }
      const addressCustomObject = contactAddresses.find(
        (address) => address.type === 'custom'
      );
      if (addressCustomObject?.address) {
        setCustomAddress(addressCustomObject);
        setCustomAddressExist(true);
      } else {
        setCustomAddress({});
      }
      console.log('addressCustomObject', addressCustomObject);
      const customAddress = addressCustomObject
        ? addressCustomObject.address
        : null;
      if (customAddress) {
        setShippingAddressOptions(
          (prevShippingAddressOptions: ShippingAddressOptionType[]) => ({
            ...prevShippingAddressOptions,
            ...{
              CUSTOM: `${customAddress.street}, ${customAddress.city}, ${customAddress.state}, ${customAddress.zipCode}`
            }
          })
        );
      }
    }
  }, [contactAddresses]);

  const onChangePhoneField = (
    value: string,
    index: any,
    feildName: string,
    isEditedField = false
  ) => {
    if (isEditedField) {
      setAddContactNumber((prevData) =>
        prevData.map((item, i) => {
          if (i === index) {
            console.log({ ...item, ['label']: value });

            return { ...item, ['label']: value };
          }
          return item;
        })
      );
    } else {
      setContactNumber((prevData) =>
        prevData.map((item, i) => {
          if (i === index) {
            setAddLabel((prevState) => {
              console.log({ addLabel_1: prevState });
              const existingItemIndex = prevState.findIndex(
                (data) => data.value === item.value
              );
              if (existingItemIndex !== -1) {
                return prevState.map((data, index) => {
                  if (index === existingItemIndex) {
                    return { ...data, label: value };
                  }
                  return data;
                });
              } else {
                return [
                  ...prevState,
                  {
                    name: 'phone',
                    value: item.value,
                    label: value || item?.label || null,
                    type: 'add',
                    source: 'ffl360',
                    license_key:
                      dealerDetail?.primaryInboundDetails.licenseKey || null
                  }
                ];
              }
            });
            return { ...item, ['label']: value };
          }
          return item;
        })
      );
    }
  };

  const getIsNotAllowedToSaveValue = () => {
    let isNotAllowed = true;
    const hasEmails = contactEmail && contactEmail.length > 0;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const hasValidChangeOwnerNewEmail = newOwnerEmail && confirmNewOwnerEmail && emailRegex.test(newOwnerEmail.trim()) && emailRegex.test(confirmNewOwnerEmail.trim()) && newOwnerEmail === confirmNewOwnerEmail;
    const bypassEmailValidationForChangeOwner = showChangeOwner && ((hasEmails && radioValue === "existing" && selectedExistingEmail) || hasValidChangeOwnerNewEmail);

    if (showUnclaimConfirm) {
    return false;
  }

    if (hasEmails && radioValue === "existing") {
      if (selectedExistingEmail) {
        isNotAllowed = false;
      }
    }

       if (!hasEmails || radioValue === "new") {
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

          if (newOwnerEmail || confirmNewOwnerEmail) {
            if (
              newOwnerEmail &&
              confirmNewOwnerEmail &&
              emailRegex.test(newOwnerEmail.trim()) &&
              emailRegex.test(confirmNewOwnerEmail.trim()) &&
              newOwnerEmail === confirmNewOwnerEmail
            ) {
              isNotAllowed = false;
            } else {
              return true;
            }
          }
        }
    
    // Check if any new items were added
    if (addContactName.length > 0) isNotAllowed = false;
    if (addContactNumber.length > 0) isNotAllowed = false;
    if (addContactEmail.length > 0) isNotAllowed = false;
    if (addContactWebsite.length > 0) isNotAllowed = false;
    
    // Check if custom address was modified
    if (Object.keys(customAddress).length > 0 && customAddress.address) {
      const hasAddressData = customAddress.address.city || customAddress.address.state || 
                            customAddress.address.street || customAddress.address.zipCode;
      if (hasAddressData) isNotAllowed = false;
    }
    
    // Check if shipping address changed
    if (defaultShippingAddress !== shippingAddressSelecValue) isNotAllowed = false;
    
    // Check if custom address was removed
    if (Object.keys(customAddress).length === 0 && removeCustom) isNotAllowed = false;
    
    // Check if any field was deleted
    if (deletedField.length > 0) isNotAllowed = false;
    
    // Check if any primary field was changed
    if (isPrimaryField.length > 0) isNotAllowed = false;
    
    // Check if any label was added/changed
    if (addLabel.length > 0) isNotAllowed = false;
    
    // Check for blank fields in new entries
    const hasBlankContactName = addContactName.some(name => !name.value || name.value.trim() === '');
    const hasBlankEmail = addContactEmail.some(email => !email.value || email.value.trim() === '');
    const hasBlankWebsite = addContactWebsite.some(website => !website.value || website.value.trim() === '');
    
    if (hasBlankContactName || hasBlankEmail || hasBlankWebsite) {
      isNotAllowed = true;
    }
    
    // Check for invalid emails in new entries
    const hasInvalidEmail = addContactEmail.some(email => {
      if (!email.value || email.value.trim() === '') return true;
      return !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email.value.trim().toString());
    });
    
    if (hasInvalidEmail) {
      isNotAllowed = true;
    }
    
    // Check for invalid websites in new entries
    const hasInvalidWebsite = addContactWebsite.some(website => {
      if (!website.value || website.value.trim() === '') return true;
      return !/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(website.value.trim().toString());
    });
    
    if (hasInvalidWebsite) {
      isNotAllowed = true;
    }
    
    // Check for validation errors - if errors exist, button should be disabled
    // When in change owner flow with valid new/selected email, bypass only email (20-contact) validation
    if (bypassEmailValidationForChangeOwner) {
      const hasNonEmailErrors = Object.keys(errors).some(key => key !== 'email' && errors[key] && Object.keys(errors[key]).length > 0);
      if (hasNonEmailErrors) isNotAllowed = true;
    } else {
      if (isAnyError()) isNotAllowed = true;
    }
    
    return isNotAllowed;
  };

  const handleSetErrors = (
    key: string,
    index: number,
    message: string | null
  ) => {
    setErrors((curr) => {
      let obj = curr;
      if (obj[key]) {
        obj[key][index] = message;
      } else {
        obj[key] = { [index]: message };
      }
      if (!message && obj[key]) {
        delete obj[key][index];
      }
      return obj;
    });
  };

  const handleGetError = (key: string, index: number) => {
    return errors[key]?.[index];
  };
  const onChangeHandler = (
    value: string | boolean,
    index: number,
    key: string,
    title: string | null = null
  ) => {
    if (title === 'contact_names_title') {
      let arr: ContactType[] = [];
      setAddContactName((prevData: ContactType[]) => {
        arr = prevData.map((item: ContactType, i: number) => {
          if (i === index) {
            const hasError = value === '' || value === null || value === undefined;
            return {
              ...item,
              [key]: value,
              errors: (hasError && key === 'value') ? 'This field is required' : undefined
            };
          }
          return item;
        });

        return arr;
      });

      resetContactNameErrors(arr);
    } else if (title === 'phone') {
      if (typeof value === 'string' && value.toString().length <= 12) {
        setAddContactNumber((prevData) => {
          const updatedData = prevData.map((item, i) => {
            if (i === index) {
              return { ...item, value, errors: undefined };
            }
            return item;
          });

          // Validate all phone numbers
          const phoneErrors = validateContactNumbers(contactNumber, updatedData);
          
          // Update errors state
          setErrors((curr) => ({
            ...curr,
            phone: phoneErrors
          }));

          // Update individual errors in the contact objects
          return updatedData.map((item, i) => ({
            ...item,
            errors: phoneErrors[i]
          }));
        });

        setShowBackendErrors((curr) => ({
          ...curr,
          phone: false
        }));
      }
    } else if (title === 'email') {
      let arr: ContactType[] = [];
      let emailValues: string[] = contactEmail.length > 0 
        ? contactEmail.map((item: ContactType) => item?.value?.toLowerCase() || '').filter(Boolean)
        : [];
      
      if (addContactEmail.length > 0) {
        const emailArray: string[] = addContactEmail
          .map((eValue: any, i: number) => {
            if (i !== index && eValue?.value) {
              return eValue.value.toLowerCase();
            }
            return undefined;
          })
          .filter((item): item is string => item !== undefined);
        
        if (emailArray.length > 0) {
          emailValues = [...emailValues, ...emailArray];
        }
      }
      
      setAddContactEmail((prevData: ContactType[]) => {
        arr = prevData.map((item: ContactType, i: number) => {
          if (i === index) {
            const emailValue = value as string;
            let errors = undefined;

            // Email validation regex
            const isEmailValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailValue);

            // Validate email
            if (emailValue && !isEmailValid) {
              errors = 'Please enter a valid email address';
            } else if (!emailValue && item.isPrimary) {
              errors = 'Primary email is required';
            } else if (emailValue && emailValues.includes(emailValue.toLowerCase())) {
              errors = 'Email already exists';
            } else {
              errors = undefined;
            }

            return {
              ...item,
              [key]: emailValue,
              errors: errors
            };
          }
          return item;
        });

        return arr;
      });

      // Always reset email errors to check for duplicates
      resetEmailErrors([...contactEmail, ...arr]);
      setShowBackendErrors((curr) => ({
        ...curr,
        email: false
      }));
    } else if (title === 'email_bypass') {
      setAddContactEmail((prevData: ContactType[]) => {
        return prevData.map((item: ContactType, i: number) => {
          if (i === index) {
            return { ...item, allowAsValidEmail: value as boolean };
          }
          return item;
        });
      });
    } else if (title === 'website') {
      let arr: ContactType[] = [];
      setAddContactWebsite((prevData: ContactType[]) => {
        arr = prevData.map((item: ContactType, i: number) => {
          if (i === index) {
            return { ...item, [key]: value };
          }
          return item;
        });
        return arr;
      });
      resetWebsiteErrors([...contactWebsite, ...arr]);
    } else if (key === 'city' || key === 'state') {
      if (value) {
      }
      const re = /^[A-Za-z\s-]+$/;
      if (value === '' || re.test(value.toString())) {
        setCustomAddress((prevAddress: any) => ({
          ...prevAddress,
          address: {
            ...prevAddress.address,
            [key]: value
          }
        }));
      }
    } else {
      setCustomAddress((prevAddress: any) => ({
        ...prevAddress,
        address: {
          ...prevAddress.address,
          [key]: value
        }
      }));
    }

    if (key === 'city') {
      if (value) {
      }
      handleSetErrors('city', 0, null);
    }
    if (key === 'state') {
      handleSetErrors('state', 0, null);
    }

    if (key === 'street') {
      handleSetErrors('street', 0, null);
    }
    if (key === 'zipCode') {
      handleSetErrors('zipCode', 0, null);
    }
  };
console.log('setAddContactNumber !!!', addContactNumber);

  const handleNameCheckboxChange = (
    event: any,
    index: any,
    data: ContactType,
    isEditedField = false
  ) => {
    console.log({ data, event, isEditedField });
    if (isEditedField) {
      const updateNamePrimary = addContactName.map((name, ind) => {
        if (index === ind && event.target.checked)
          return { ...name, isPrimary: true };
        return { ...name, isPrimary: false };
      });
      setAddContactName(updateNamePrimary);
      if (event.target.checked) {
        const updateList = contactName.map((name, ind) => ({
          ...name,
          isPrimary: false
        }));
        setContactName(updateList);
      }
    } else {
      const updateNamePrimary = contactName.map((name, ind) => {
        if (index === ind && event.target.checked)
          return { ...name, isPrimary: true };
        return { ...name, isPrimary: false };
      });
      setContactName(updateNamePrimary);
      if (event.target.checked) {
        const updateList = addContactName.map((name, ind) => ({
          ...name,
          isPrimary: false
        }));
        setAddContactName(updateList);
      }
      setIsPrimaryField((prevState) => {
        const newItem = {
          name: 'primary_contact_names',
          value: data.value,
          type: 'add',
          source: 'ffl360',
          license_key: dealerDetail?.primaryInboundDetails.licenseKey
        };
        if (event.target.checked) {
          const existingItemIndex = prevState.findIndex((item: any) => item.name === newItem.name);
          if (existingItemIndex !== -1) {
              const updatedState: any = [...prevState];  
              updatedState[existingItemIndex] = newItem;
              return updatedState;
          } else {
              return [...prevState, newItem];
          }
        } else
          return prevState.filter(
            (item: any) => item.name !== 'primary_contact_names'
          );
      });
    }
  };
  const handlePhoneCheckboxChange = (
    event: any,
    index: any,
    data: ContactType,
    isEditedField = false
  ) => {
    if (isEditedField) {
      const updatePhonePrimary = addContactNumber.map((phone, ind) => {
        if (index === ind && event.target.checked)
          return { ...phone, isPrimary: true };
        return { ...phone, isPrimary: false };
      });
      setAddContactNumber(updatePhonePrimary);
      if (event.target.checked) {
        const updateList = contactNumber.map((phone, ind) => ({
          ...phone,
          isPrimary: false
        }));
        setContactNumber(updateList);
      }
    } else {
      const updatePhonePrimary = contactNumber.map((phone, ind) => {
        if (index === ind && event.target.checked)
          return { ...phone, isPrimary: true };
        return { ...phone, isPrimary: false };
      });
      setContactNumber(updatePhonePrimary);
      if (event.target.checked) {
        const updateList = addContactNumber.map((phone, ind) => ({
          ...phone,
          isPrimary: false
        }));
        setAddContactNumber(updateList);
      }
      setIsPrimaryField((prevState) => {
        const newItem = {
          name: 'is_primary_phone',
          value: data.value,
          type: 'add',
          source: 'ffl360',
          license_key: dealerDetail?.primaryInboundDetails.licenseKey
        };
        if (event.target.checked) {
          const existingItemIndex = prevState.findIndex((item: any) => item.name === newItem.name);
          if (existingItemIndex !== -1) {
              const updatedState: any = [...prevState];  
              updatedState[existingItemIndex] = newItem;
              return updatedState;
          } else {
              return [...prevState, newItem];
          }
        } else
          return prevState.filter(
            (item: any) => item.name !== 'is_primary_phone'
          );
      });
    }
  };
  
  const handleEmailCheckboxChange = (
    event: any,
    index: any,
    data: ContactType,
    isEditedField = false
  ) => {
    if (isEditedField) {
      const updateEmailPrimary = addContactEmail.map((email, ind) => {
        if (index === ind && event.target.checked)
          return { ...email, isPrimary: true };
        return { ...email, isPrimary: false };
      });
      setAddContactEmail(updateEmailPrimary);
      if (event.target.checked) {
        const updateList = contactEmail.map((email, ind) => ({
          ...email,
          isPrimary: false
        }));
        setContactEmail(updateList);
      }
    } else {
      const updateEmailPrimary = contactEmail.map((email, ind) => {
        if (index === ind && event.target.checked)
          return { ...email, isPrimary: true };
        return { ...email, isPrimary: false };
      });
      setContactEmail(updateEmailPrimary);
      if (event.target.checked) {
        const updateList = addContactEmail.map((email, ind) => ({
          ...email,
          isPrimary: false
        }));
        setAddContactEmail(updateList);
      }
      console.log({ checkedTest: event.target.checked });

      setIsPrimaryField((prevState) => {
        const newItem = {
          name: 'is_primary_email',
          value: data.value,
          type: 'add',
          source: 'ffl360',
          license_key: dealerDetail?.primaryInboundDetails.licenseKey
        };
        if (event.target.checked) {
          const existingItemIndex = prevState.findIndex((item: any) => item.name === newItem.name);
          if (existingItemIndex !== -1) {
              const updatedState: any = [...prevState];  
              updatedState[existingItemIndex] = newItem;
              return updatedState;
          } else {
              return [...prevState, newItem];
          }
        } else
          return prevState.filter(
            (item: any) => item.name !== 'is_primary_email'
          );
      });
    }
    if(addContactEmail && addContactEmail.length > 0){
      resetEmailErrors(addContactEmail);
    }
  };
  const handleWebURLCheckboxChange = (
    event: any,
    index: any,
    data: ContactType,
    isEditedField = false
  ) => {
    if (isEditedField) {
      const updateWebsitePrimary = addContactWebsite.map((website, ind) => {
        if (index === ind && event.target.checked)
          return { ...website, isPrimary: true };
        return { ...website, isPrimary: false };
      });
      setAddContactWebsite(updateWebsitePrimary);
      if (event.target.checked) {
        const updateList = contactWebsite.map((website, ind) => ({
          ...website,
          isPrimary: false
        }));
        setContactWebsite(updateList);
      }
    } else {
      const updateWebsitePrimary = contactWebsite.map((website, ind) => {
        if (index === ind && event.target.checked)
          return { ...website, isPrimary: true };
        return { ...website, isPrimary: false };
      });
      setContactWebsite(updateWebsitePrimary);
      if (event.target.checked) {
        const updateList = addContactWebsite.map((website, ind) => ({
          ...website,
          isPrimary: false
        }));
        setAddContactWebsite(updateList);
      }
      setIsPrimaryField((prevState) => {
        const newItem = {
          name: 'primary_web_url',
          value: data.value,
          type: 'add',
          source: 'ffl360',
          license_key: dealerDetail?.primaryInboundDetails.licenseKey
        };
        if (event.target.checked) {
          const existingItemIndex = prevState.findIndex((item: any) => item.name === newItem.name);
          if (existingItemIndex !== -1) {
              const updatedState: any = [...prevState];  
              updatedState[existingItemIndex] = newItem;
              return updatedState;
          } else {
              return [...prevState, newItem];
          }
        } else
          return prevState.filter(
            (item: any) => item.name !== 'primary_web_url'
          );
      });
    }
  };
  const onClickAddName = () => {
    setAddContactName([
      ...addContactName,
      {
        isPrimary:
          contactName.length === 0 && addContactName.length === 0
            ? true
            : false,
        value: ''
      }
    ]);
  };
  const onClickAddPhone = () => {
    const newPhone = {
      isAtf: false,
      label: null,
      isPrimary: contactNumber.length === 0 && addContactNumber.length === 0
        ? true
        : false,
      value: ''
    };
    
    setAddContactNumber((prev) => {
      const updated = [...prev, newPhone];
      
      // Validate all phone numbers
      const phoneErrors = validateContactNumbers(contactNumber, updated);
      
      // Update errors state
      setErrors((curr) => ({
        ...curr,
        phone: phoneErrors
      }));
      
      return updated;
    });
  };
  const onClickAddEmail = () => {
    setAddContactEmail([
      ...addContactEmail,
      {
        isPrimary:
          contactEmail.length === 0 && addContactEmail.length === 0
            ? true
            : false,
        value: ''
      }
    ]);
  };
  const onClickAddWebsite = () => {
    setAddContactWebsite([
      ...addContactWebsite,
      {
        isPrimary:
          contactWebsite.length === 0 && addContactWebsite.length === 0
            ? true
            : false,
        value: ''
      }
    ]);
  };
  const onChangeDefaultShippingAddress = (arg: string) => {
    console.log({ arg });
    setShippingAddressSelecValue(arg);
  };

  const sanitizeContactNumber = (str: string) => {
    console.log('sanatixed str', str.replace(/[^0-9]/g, ''));
    return str.replace(/[^0-9]/g, '');
  };
  const onClickDeleteHandler = (
    index: number,
    setFunc: any,
    name: string,
    value: string,
    isExist = false,
    errorName?: string,
    isExisting?: boolean
  ) => {
    if (
      (name === 'contact_names_title' ||
        name === 'phone' ||
        name === 'email' ||
        name === 'web_url') &&
      isExist
    ) 
      setDeletedField([
        ...deletedField,
        {
          name: name,
          value: value,
          type: 'remove',
          license_key: dealerDetail?.primaryInboundDetails.licenseKey || ''
        }
      ]);

    setFunc((prevData: ContactType[]) => {
      const arr = prevData.filter(
        (item: ContactType, i: number) => i !== index
      );

      if (isExisting) {
        return arr;
      }
      if (name === 'email') {
        resetEmailErrors([...contactEmail, ...arr]);
        // Clear the specific error for deleted email
        setErrors((curr) => {
          const newErrors = { ...curr };
          if (newErrors.email && newErrors.email[index + contactEmail.length]) {
            delete newErrors.email[index + contactEmail.length];
          }
          return newErrors;
        });
      } else if (name === 'phone') {
        // Revalidate remaining phone numbers
        const phoneErrors = validateContactNumbers(contactNumber, arr);
        setErrors((curr) => ({
          ...curr,
          phone: phoneErrors
        }));
      } else if (name === 'web_url') {
        resetWebsiteErrors([...contactWebsite, ...arr]);
        // Clear the specific error for deleted website
        setErrors((curr) => {
          const newErrors = { ...curr };
          if (newErrors.website && newErrors.website[index + contactWebsite.length]) {
            delete newErrors.website[index + contactWebsite.length];
          }
          return newErrors;
        });
      } else if (name === 'contact_names_title') {
        resetContactNameErrors([...contactName, ...arr]);
        // Clear the specific error for deleted contact name
        setErrors((curr) => {
          const newErrors = { ...curr };
          if (newErrors.contact_names_title && newErrors.contact_names_title[index]) {
            delete newErrors.contact_names_title[index];
          }
          return newErrors;
        });
      }
      return arr;
    });
  };
  console.log('errors', errors);
  const onClickAddCustomAddress = () => {
    setRemoveCustom(false);
    setCustomAddress({
      type: 'custom',
      address: {
        state: '',
        zipCode: '',
        street: '',
        city: ''
      },
      isPrimary: false
    });
  };
  const getFloatingLabel = (labels: Array<string>) => {
    return labels.map((label) =>
      label.includes('CUSTOM') ? 'PHYSICAL' : label
    );
  };
  console.log({ contactAddresses });

  console.log({ isPrimaryField });

  console.log({ emailBackendError });

  const onSubmitHandler = async () => {
    let isInvalid = false;
    
    setShowBackendErrors({
      phone: true,
      email: true
    });
    if (customAddress) {
      if (customAddress.address?.city.length === 0) {
        handleSetErrors('city', 0, 'City can not be blank');
        isInvalid = true;
      }

      if (customAddress.address?.state.length === 0) {
        handleSetErrors('state', 0, 'State can not be blank');
        isInvalid = true;
      }
      if (customAddress.address?.street.length === 0) {
        handleSetErrors('street', 0, 'Street can not be blank');
        isInvalid = true;
      }
      if (customAddress.address?.zipCode.length === 0) {
        handleSetErrors('zipCode', 0, 'Zip Code can not be blank');
        isInvalid = true;
      }
    }

    if (isInvalid) return;
    const licenseKey = dealerDetail?.primaryInboundDetails.licenseKey as string;
    
    await dispatch(setIsCreateDealerActionInprogress(true));
    const labelsContactNumberAction = addContactNumber
      ? await addContactNumber.map((phoneField, index) => {
        const phone:any = phoneField.value?.trim();
        const digitsOnly = phone.replace(/\D/g, "");
          const response = [
            {
              name: 'phone',
              value: digitsOnly,
              type: 'add',
              source: 'ffl360',
              label: phoneField.label?.trim(),
              license_key: licenseKey
            }
          ];
          if (phoneField.isPrimary)
            response.push({
              name: 'is_primary_phone',
              value: digitsOnly,
              type: 'add',
              source: 'ffl360',
              label: phoneField.label?.trim(),
              license_key: licenseKey
            });
          return response;
        })
      : [];
     const ownerEmail =
        radioValue === "existing"
          ? selectedExistingEmail
          : newOwnerEmail;

    const ownerEmailAction =
      ownerEmail ? [
            {
              name: "change_claimed_email",
              type: "update",
              old_email: claimedData?.email || '',
              new_email: ownerEmail.trim(),
              license_key: licenseKey,
              source: "ffl360",
            }
          ]
        : [];
        const unclaimProfileAction = isUnclaimProfile ? [
              {
                name: "unclaim_dealer_profile",
                type: "update",
                license_key: licenseKey,
                source: "ffl360"
              }
            ]
          : [];
    const labelsContactNameAction = addContactName
      ? await addContactName.map((nameField, index) => {
          const response = [
            {
              name: 'contact_names_title',
              value: nameField.value?.trim(),
              type: 'add',
              source: 'ffl360',
              title: nameField?.title,
              license_key: licenseKey
            }
          ];
          if (nameField.isPrimary)
            response.push({
              name: 'primary_contact_names',
              value: nameField.value?.trim(),
              type: 'add',
              source: 'ffl360',
              title: nameField?.title,
              license_key: licenseKey
            });
          return response;
        })
      : [];
      const filteredEmails = addContactEmail && addContactEmail.length > 0 ? addContactEmail.filter(email => email.value?.trim() !== '') : [];
      const labelsContactEmailAction = (filteredEmails && filteredEmails.length > 0 ) 
      ? await filteredEmails.map((emailField, index) => {
          const response = [
            {
              name: 'email',
              value: emailField.value?.trim(),
              type: 'add',
              source: 'ffl360',
              allowAsValidEmail: emailField.allowAsValidEmail,
              license_key: licenseKey
            }
          ];
          if (emailField.isPrimary)
            response.push({
              name: 'is_primary_email',
              value: emailField.value?.trim(),
              type: 'add',
              source: 'ffl360',
              license_key: licenseKey,
              allowAsValidEmail: false
            });
          return response;
        })
      : [];
    const labelsContactWebsiteAction = addContactWebsite
      ? await addContactWebsite.map((websiteField, index) => {
          const response = [
            {
              name: 'web_url',
              value: websiteField.value?.trim(),
              type: 'add',
              source: 'ffl360',
              license_key: licenseKey
            }
          ];
          if (websiteField.isPrimary)
            response.push({
              name: 'primary_web_url',
              value: websiteField.value?.trim(),
              type: 'add',
              source: 'ffl360',
              license_key: licenseKey
            });
          return response;
        })
      : [];

    // NEW: Create preferred shipping address payload
    const createAddressPayload = () => {
      if (shippingAddressSelecValue === defaultShippingAddress) {
        return null; // No change in shipping address
      }

      // Find the selected address from contactAddresses
      const selectedAddress = contactAddresses.find(
        (address) => address.type?.toUpperCase() === shippingAddressSelecValue
      );

      if (!selectedAddress || !selectedAddress.address) {
        return null;
      }

      return {
        name: 'preferred_shipping_address',
        value: selectedAddress.type,
        type: 'add',
        source: 'ffl360',
        license_key: licenseKey
      };
    };

    const addressPayload = createAddressPayload();

    const defaultShippingAddressPayload = { type: shippingAddressSelecValue };

    const labelAction = [
      ...deletedField,
      ...labelsContactNameAction.flat(),
      ...labelsContactNumberAction.flat(),
      ...labelsContactEmailAction.flat(),
      ...labelsContactWebsiteAction.flat(),
      ...isPrimaryField,
      ...(addressPayload ? [addressPayload] : []), // Add address payload if it exists
      ...ownerEmailAction,
      ...unclaimProfileAction     
    ];
    console.log({ labelAction });
    const customAddressAction: CustomAddress = {
      city: customAddress.address?.city || '',
      state: customAddress.address?.state || '',
      street: customAddress.address?.street || '',
      zipcode: customAddress.address?.zipCode || ''
    };

    const payload: any = {
      actionList: labelAction, // Updated to include address payload
      addCustomAddressPayload:
        Object.keys(customAddress).length > 0
          ? { data: [customAddressAction], licenseKey }
          : undefined,
      updateCustomAddress:
        Object.keys(customAddress).length > 0 &&
          shippingAddressSelecValue !== ''
          ? customAddressAction
          : undefined,
      defaultShippingAddress:
        shippingAddressSelecValue !== ''
          ? defaultShippingAddressPayload
          : undefined,
      licenseKey: licenseKey,
      removeCustomAddressIds: removeCustom && [0],
      dealerId: dealerId
    };
    console.log({ payload });

    dispatch(callToCreateDealerAction(payload));
  };

  const isAnyError = () => {
    let exists = false;
    for (let key in errors) {
      console.log('erros in any error', errors[key], errors, Object.keys(errors[key]))
      exists = Object.keys(errors[key]).length > 0;
    }

    return exists;
  };

  const getEmailBackendError = (name: 'email' | 'phone') => {
    if (name === 'email' && !showBackendErrors.email) {
      return {};
    }
    if (name === 'phone' && !showBackendErrors.phone) {
      return {};
    }
    const errorObj: { [key: number]: string } = {};
    const errors = getBackendValidationError(name);
    if(bouncedEmailError==='Email already marked as bounced. Please use a different email.'){
      errorObj[0] = bouncedEmailError;
      return errorObj;
    }
    if (errors.length > 0) {
      errors.map((_, index) => {
        errorObj[index] =
          name === 'email'
            ? 'Enter a valid email Id'
            : 'Enter a valid contact number';
      });

      return errorObj;
    } else {
      return {};
    }
  };
  const handleContactNumberPaste = (event: ClipboardEvent<HTMLInputElement>, index: any): void => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    const digitsOnly = pastedText.replace(/\D/g, "");
    if (digitsOnly) {
      onChangeHandler(digitsOnly, index, 'value', 'phone')
    }
  };

  const handleContactNamePaste = (event: ClipboardEvent<HTMLInputElement>, index: number): void => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    const trimmedText = pastedText.trim();
    if (trimmedText) {
      onChangeHandler(trimmedText, index, 'value', 'contact_names_title');
    }
  };

  const handleContactTitlePaste = (event: ClipboardEvent<HTMLInputElement>, index: number): void => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    const trimmedText = pastedText.trim();
    if (trimmedText) {
      onChangeHandler(trimmedText, index, 'title', 'contact_names_title');
    }
  };

  const handleEmailPaste = (event: ClipboardEvent<HTMLInputElement>, index: number): void => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    const trimmedText = pastedText.trim();
    if (trimmedText) {
      onChangeHandler(trimmedText, index, 'value', 'email');
    }
  };

  const handleWebsitePaste = (event: ClipboardEvent<HTMLInputElement>, index: number): void => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    const trimmedText = pastedText.trim();
    if (trimmedText) {
      onChangeHandler(trimmedText, index, 'value', 'website');
    }
  };

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={iscontactDetailsEditOpen}
        onClose={oncontactDetailsEditClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          className={`transfer-create-modal`}
          maxWidth={'534px'}
          maxHeight={'90vh'}
          scrollBehavior={'auto'}
        >
          <ModalHeader className="store-contact-details-edit-header">
            Edit Store Contact Details
            <button
              className="transfer-create-modal__close-btn"
              onClick={oncontactDetailsEditClose}
            >
              <img src="/images/ui/close.svg" />
            </button>
          </ModalHeader>
          {/* contact name fields */}
          <ModalBody className={'store-contact-details-edit-body'} sx={{ padding: '0 !important' }}>
            {claimedData.isClaimed && isGlobalAdmin  &&(
              <>
              <Box className='contact-edit-tabs'>
              <Button
                className={activeTab === 'contact' ? 'active-tab' : ''}
                onClick={() => setActiveTab('contact')}
              >
                Contact Details
              </Button>

              <Button
                className={activeTab === 'claim' ? 'active-tab' : ''}
                onClick={() => setActiveTab('claim')}
              >
                Claim Profile Controls
              </Button>
            </Box>
              </>
            )}
            
            {activeTab === 'contact' && (
            <Box className={'contact-details-edit-container'}>
              <div className="contact-details-box">
                <Box className="contact-details-title">Contact Name:</Box>
                {contactName &&
                  contactName.map((name: ContactType, index: number) => (
                    <Box key={index} className={'contact-details-input-box'}>
                      <Input
                        className="contact-details-input"
                        type="text"
                        value={name.value ?? ''}
                        disabled
                        placeholder="Enter Name"
                        required
                      />
                      <Input
                        className="contact-details-input-title"
                        type="text"
                        value={name.title ?? ''}
                        disabled
                        placeholder="Enter Contact Title"
                        required
                      />
                      <Box className="contact-edit__checkbox-wrapper">
                        <CustomRadio
                          name={'primary_name'}
                          value={name.isPrimary}
                          id={`edit-name-label-${index}`}
                          isChecked={name.isPrimary as boolean}
                          onChange={(e) => {
                            handleNameCheckboxChange(e, index, name);
                          }}
                        />
                        <label
                          className={`contact-edit__checkbox-label active-label`}
                          htmlFor={`edit-name-label-${index}`}
                        >
                          Primary
                        </label>
                      </Box>
                      <Button
                        className="license-edit__delete"
                        isDisabled={Boolean(name.isPrimary)}
                        onClick={() =>
                          onClickDeleteHandler(
                            index,
                            setContactName,
                            'contact_names_title',
                            name.value ?? '',
                            true,
                            undefined,
                            true
                          )
                        }
                      >
                        <Image
                          src={
                            name.isPrimary
                              ? '/images/ui/delete-disabled-2.svg'
                              : '/images/ui/delete-red-2.svg'
                          }
                          width="22.39px"
                          height="22.39px"
                          alt="Delete Icon"
                        />
                      </Button>
                    </Box>
                  ))}
                {addContactName &&
                  addContactName.map((name: ContactType, index: number) => (
                    <FormControl
                      className="form-control-box"
                      key={index}
                      isInvalid={!!name.errors}
                    >
                      <Box className={'contact-details-input-box'}>
                        <Input
                          className="contact-details-input"
                          type="text"
                          value={name.value ?? ''}
                          onChange={(e) =>
                            onChangeHandler(
                              e.target.value,
                              index,
                              'value',
                              'contact_names_title'
                            )
                          }
                          onPaste={(e) => handleContactNamePaste(e, index)}
                          placeholder="Enter Name"
                          required
                        />
                        <Input
                          className="contact-details-input-title"
                          type="text"
                          value={name.title ?? ''}
                          onChange={(e) =>
                            onChangeHandler(
                              e.target.value,
                              index,
                              'title',
                              'contact_names_title'
                            )
                          }
                          onPaste={(e) => handleContactTitlePaste(e, index)}
                          placeholder="Enter Contact Title"
                          // required
                        />
                        <Box className="contact-edit__checkbox-wrapper">
                          <CustomRadio
                            name={'primary_name'}
                            value={name.isPrimary}
                            id={`edit-name-label-${index}`}
                            isChecked={name.isPrimary as boolean}
                            onChange={(e) =>
                              handleNameCheckboxChange(
                                e,
                                index,
                                { ...name, value: name.value },
                                true
                              )
                            }
                          />
                          <label
                            className={`contact-edit__checkbox-label active-label`}
                            htmlFor={`edit-name-label-${index}`}
                          >
                            Primary
                          </label>
                        </Box>
                        <Button
                          className="license-edit__delete"
                          isDisabled={Boolean(name.isPrimary)}
                          onClick={() =>
                            onClickDeleteHandler(
                              index,
                              setAddContactName,
                              'contact_names_title',
                              name.value ?? '',
                              false,
                              'contact_names_title'
                            )
                          }
                        >
                          <Image
                            src={
                              name.isPrimary
                                ? '/images/ui/delete-disabled-2.svg'
                                : '/images/ui/delete-red-2.svg'
                            }
                            width="22.39px"
                            height="22.39px"
                            alt="Delete Icon"
                          />
                        </Button>
                      </Box>
                      <ErrorMessage
                        message={
                          name.errors ??
                          handleGetError('contact_names_title', index) ??
                          null
                        }
                      />
                    </FormControl>
                  ))}

                <button
                  className="add-more-text"
                  disabled={
                    contactName.length +
                    (addContactName ? addContactName?.length : 0) >=
                    3
                  }
                  onClick={onClickAddName}
                >
                  +Add More
                </button>
              </div>
              {/* contact number fields */}
              <div className="contact-details-box">
                <Box className="contact-details-title">Contact Number:</Box>
                {contactNumber &&
                  contactNumber.map((phone: ContactType, index: number) => (
                    <Box key={index} className={'contact-details-input-box'}>
                      <InputMask
                        id="formattedInput"
                        mask="999-999-9999"
                        className="contact-details-input phone-mask-input"
                        placeholder="xxx-xxx-xxxx"
                        value={phone.value ?? ''}
                        disabled
                      >
                        {(inputProps: any) => <input
                          {...inputProps}
                          type="text"
                          disabled
                          className="contact-details-input phone-mask-input"
                        />
                        }
                      </InputMask>
                      {contactNumber.some((phone: ContactType) => phone.isAtf) && (
                        <Box className="de-atf-tag" sx={{ visibility: phone?.isAtf ? 'visible' : 'hidden' }}>ATF</Box>
                      )}
                      <Box className="contact-edit__checkbox-wrapper">
                        <CustomRadio
                          name={'primary_phone'}
                          id={`edit-phone-label-${index}`}
                          value="primary_phone"
                          isChecked={!!phone.isPrimary as boolean}
                          onChange={(e) =>
                            handlePhoneCheckboxChange(e, index, phone)
                          }
                        />
                        <label
                          className={`contact-edit__checkbox-label active-label`}
                          htmlFor={`edit-phone-label-${index}`}
                        >
                          Primary
                        </label>
                      </Box>
                      <Button
                        className="license-edit__delete"
                        isDisabled={Boolean(phone.isPrimary) || Boolean(phone.isAtf)}
                        onClick={() =>
                          onClickDeleteHandler(
                            index,
                            setContactNumber,
                            'phone',
                            phone.value ?? '',
                            true,
                            undefined,
                            true
                          )
                        }
                      >
                        <Image
                          src={
                            (phone.isPrimary || phone.isAtf)
                              ? '/images/ui/delete-disabled-2.svg'
                              : '/images/ui/delete-red-2.svg'
                          }
                          width="22.39px"
                          height="22.39px"
                          alt="Delete Icon"
                        />
                      </Button>
                    </Box>
                  ))}
                {addContactNumber &&
                  addContactNumber.map((phone: ContactType, index: number) => (
                    <FormControl
                      className="form-control-box"
                      key={index}
                      isInvalid={!!phone.errors}
                    >
                      <Box className={'contact-details-input-box'}>
                        <InputMask
                          type="text"
                          mask="999-999-9999"
                          className="contact-details-input phone-mask-input"
                          placeholder="xxx-xxx-xxxx"
                          value={phone.value ?? ''}
                          onChange={(e: any) => {
                            onChangeHandler(
                              e.target.value,
                              index,
                              'value',
                              'phone'
                            )
                          }
                          }
                          onPaste={(e: any) => handleContactNumberPaste(e, index)}
                        >
                          {(inputProps: any) => <input
                            {...inputProps}
                            type="text"
                            className="contact-details-input phone-mask-input"
                          />
                          }
                        </InputMask>
                        {contactNumber.some((phone: ContactType) => phone.isAtf) && (
                          <Box className="de-atf-tag" sx={{ visibility:'hidden' }}>ATF</Box>
                        )}
                        <Box className="contact-edit__checkbox-wrapper">
                          <CustomRadio
                            name={'primary_phone'}
                            id={`edit-phone-label-${index}`}
                            value="primary_phone"
                            isChecked={!!phone.isPrimary as boolean}
                            onChange={(e) =>
                              handlePhoneCheckboxChange(
                                e,
                                index,
                                { ...phone, value: phone.value },
                                true
                              )
                            }
                          />
                          <label
                            className={`contact-edit__checkbox-label active-label`}
                            htmlFor={`edit-phone-label-${index}`}
                          >
                            Primary
                          </label>
                        </Box>
                        <Button
                          className="license-edit__delete"
                          isDisabled={Boolean(phone.isPrimary) || Boolean(phone.isAtf)}
                          onClick={() =>
                            onClickDeleteHandler(
                              index,
                              setAddContactNumber,
                              'phone',
                              phone.value ?? '',
                              false,
                              'phone'
                            )
                          }
                        >
                          <Image
                            src={
                              (phone.isPrimary || phone.isAtf) 
                                ? '/images/ui/delete-disabled-2.svg'
                                : '/images/ui/delete-red-2.svg'
                            }
                            width="22.39px"
                            height="22.39px"
                            alt="Delete Icon"
                          />
                        </Button>
                      </Box>
                      <ErrorMessage
                        message={
                          handleGetError('phone', index) ??
                          getEmailBackendError('phone')[index] ?? null
                        }
                      />
                    </FormControl>
                  ))}

                <button className="add-more-text" onClick={onClickAddPhone}>
                  +Add More
                </button>
              </div>
              {/* Email fields */}
              <div className="contact-details-box">
                <Box className="contact-details-title change-owner">
                  Email: 
                  {claimedData.isClaimed && isGlobalAdmin && (
                    <>
                      <Button className='contact-change-owner-btn' onClick={() => setActiveTab('claim')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M1.99902 7.99665C1.99902 6.40601 2.6309 4.88052 3.75565 3.75577C4.8804 2.63102 6.40589 1.99915 7.99652 1.99915C9.67319 2.00545 11.2825 2.65969 12.488 3.82505L13.994 5.33109" stroke="white" stroke-width="1.33278" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M13.9941 1.99915V5.33109H10.6621" stroke="white" stroke-width="1.33278" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M13.994 7.99664C13.994 9.58728 13.3621 11.1128 12.2374 12.2375C11.1126 13.3623 9.58716 13.9941 7.99652 13.9941C6.31986 13.9878 4.71054 13.3336 3.50506 12.1682L1.99902 10.6622" stroke="white" stroke-width="1.33278" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M5.33097 10.6622H1.99902V13.9942" stroke="white" stroke-width="1.33278" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Change Owner
                      </Button>
                    </>
                  )}                  
                </Box>
                {claimedData.isClaimed && isGlobalAdmin && (
                  <>
                    <Box className={'contact-profile-owner-box'}>
                      <Box className={'user-icon'}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <g clip-path="url(#clip0_16861_23834)">
                            <path d="M13.3278 17.4927V15.8268C13.3278 14.9431 12.9768 14.0956 12.3519 13.4707C11.7271 12.8459 10.8796 12.4948 9.99588 12.4948H4.99796C4.11427 12.4948 3.26678 12.8459 2.64192 13.4707C2.01706 14.0956 1.66602 14.9431 1.66602 15.8268V17.4927" stroke="#3F3F45" stroke-width="1.66597" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.49698 9.16285C9.33717 9.16285 10.8289 7.67109 10.8289 5.83091C10.8289 3.99073 9.33717 2.49896 7.49698 2.49896C5.6568 2.49896 4.16504 3.99073 4.16504 5.83091C4.16504 7.67109 5.6568 9.16285 7.49698 9.16285Z" stroke="#3F3F45" stroke-width="1.66597" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M13.3281 9.16286L14.9941 10.8288L18.326 7.49689" stroke="#3F3F45" stroke-width="1.66597" stroke-linecap="round" stroke-linejoin="round"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_16861_23834">
                              <rect width="19.9917" height="19.9917" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                        <Text className={'profile-owner-title'}>Profile Owner</Text>
                      </Box>
                      <Text className={'profile-owner-description'}>All login credentials and password resets are sent to this email address.</Text>
                      <Box className="email-box" style={{ position: "relative", display: "flex", alignItems: "center", gap: "6px" }}>
                        <Text className="profile-owner-email">{claimedData.email}</Text>

                        <Box onClick={handleCopy} style={{ cursor: "pointer", position: "relative", paddingTop: "8px" }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <g clipPath="url(#clip0_17415_30213)">
                              <path d="M13.333 5.33334H6.66634C5.92996 5.33334 5.33301 5.9303 5.33301 6.66668V13.3333C5.33301 14.0697 5.92996 14.6667 6.66634 14.6667H13.333C14.0694 14.6667 14.6663 14.0697 14.6663 13.3333V6.66668C14.6663 5.9303 14.0694 5.33334 13.333 5.33334Z" stroke="#0C1E46" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                              <path d="M2.66634 10.6667C1.93301 10.6667 1.33301 10.0667 1.33301 9.33334V2.66668C1.33301 1.93334 1.93301 1.33334 2.66634 1.33334H9.33301C10.0663 1.33334 10.6663 1.93334 10.6663 2.66668" stroke="#0C1E46" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </g>
                            <defs>
                              <clipPath id="clip0_17415_30213">
                                <rect width="16" height="16" fill="white"/>
                              </clipPath>
                            </defs>
                          </svg>

                          {copied && (
                            <Box
                              style={{
                                position: "absolute",
                                top: "-25px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                background: "#333",
                                color: "#fff",
                                fontSize: "12px",
                                padding: "3px 8px",
                                borderRadius: "4px",
                                whiteSpace: "nowrap"
                              }}
                            >
                              Copied
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </>
                )}
                
                {contactEmail &&
                  contactEmail.map((email: ContactType, index: number) => (
                    <Box key={index} className={'contact-details-input-box'}>
                      <Input
                        className={`contact-details-input ${email?.bounced && email?.bounced !==null ? 'bounced-email' : ''}`}
                        type="email"
                        value={email.value ?? ''}
                        disabled
                        placeholder="Enter Email"
                      />
                      <Box className="contact-edit__checkbox-wrapper">
                        <CustomRadio
                          name={'primary_email'}
                          id={`edit-email-label-${index}`}
                          value={email.isPrimary}
                          isChecked={email.isPrimary as boolean}
                          isDisabled={(email?.bounced && email?.bounced !==null) ? true : false}
                          onChange={(e) =>
                            handleEmailCheckboxChange(e, index, email)
                          }
                        />
                        <label
                          className={`contact-edit__checkbox-label active-label`}
                          htmlFor={`edit-email-label-${index}`}
                        >
                          Primary
                        </label>
                      </Box>
                      <Button
                        className="license-edit__delete"
                        // isDisabled={Boolean(email.isPrimary)}
                        onClick={() =>
                          onClickDeleteHandler(
                            index,
                            setContactEmail,
                            'email',
                            email.value ?? '',
                            true,
                            undefined,
                            true
                          )
                        }
                      >
                        <Image
                          src={
                            // email.isPrimary
                            //   ? '/images/ui/delete-disabled-2.svg'
                            //   : '/images/ui/delete-red-2.svg'
                            '/images/ui/delete-red-2.svg'
                          }
                          width="22.39px"
                          height="22.39px"
                          alt="Delete Icon"
                        />
                      </Button>
                    </Box>
                  ))}
                {addContactEmail &&
                  addContactEmail.map((email: ContactType, index: number) => (
                    <FormControl
                      className="form-control-box"
                      key={index}
                      isInvalid={!!email.errors}
                    >
                      <Box className={'contact-details-input-box'}>
                        <Input
                          className="contact-details-input"
                          type="email"
                          value={email.value ?? ''}
                          onChange={(e) =>
                            onChangeHandler(
                              e.target.value,
                              index,
                              'value',
                              'email'
                            )
                          }
                          onPaste={(e) => handleEmailPaste(e, index)}
                          placeholder="Enter Email"
                        />
                        <Box className="contact-edit__checkbox-wrapper">
                          <CustomRadio
                            name={'primary_email'}
                            id={`edit-email-label-${index}`}
                            value={email.isPrimary}
                            isChecked={email.isPrimary as boolean}
                            onChange={(e) =>
                              handleEmailCheckboxChange(
                                e,
                                index,
                                { ...email, value: email.value },
                                true
                              )
                            }
                          />
                          <label
                            className={`contact-edit__checkbox-label active-label`}
                            htmlFor={`edit-email-label-${index}`}
                          >
                            Primary
                          </label>
                        </Box>
                        <Button
                          className="license-edit__delete"
                          isDisabled={Boolean(email.isPrimary)}
                          onClick={() =>
                            onClickDeleteHandler(
                              index,
                              setAddContactEmail,
                              'email',
                              email.value ?? '',
                              false,
                              'email'
                            )
                          }
                        >
                          <Image
                            src={
                              email.isPrimary
                                ? '/images/ui/delete-disabled-2.svg'
                                : '/images/ui/delete-red-2.svg'
                            }
                            width="22.39px"
                            height="22.39px"
                            alt="Delete Icon"
                          />
                        </Button>
                      </Box>
                      <ErrorMessage
                        message={
                          email.errors ??
                          handleGetError('email', index + contactEmail.length) ??
                          getEmailBackendError('email')[index] ??
                          null
                        }
                      />
                      {/* {getEmailBackendError('email')[index] && (
                        <Checkbox
                          onChange={(e) =>
                            onChangeHandler(
                              e.target.checked,
                              index,
                              'email_bypass',
                              'email_bypass'
                            )
                          }
                        >
                          Proceed anyway
                        </Checkbox>
                      )} */}
                    </FormControl>
                  ))}
                <button
                  className="add-more-text"
                  disabled={
                    contactEmail.length +
                    (addContactEmail ? addContactEmail?.length : 0) >=
                    20
                  }
                  onClick={onClickAddEmail}
                >
                  +Add More
                </button>
                {/* <ErrorMessage message={getEmailBackendError()} /> */}
              </div>
              {/* address fields */}
              <div className="contact-details-box">
                <Box className="contact-details-title">Preferred Shipping Address:</Box>
                
                {/* Premise Address */}
                {shippingAddressOptions?.PREMISE && (
                  <Box 
                    className={'contact-details-input-box address-row clickable-address'}
                    onClick={() => onChangeDefaultShippingAddress('PREMISE')}
                  >
                    <Box className="contact-details-address-text single-line">
                      <Text className="address-label">Premise Address:</Text>
                      <Text className="address-value-single-line">
                        {shippingAddressOptions.PREMISE}
                      </Text>
                    </Box>
                    <Box className="contact-edit__checkbox-wrapper address-primary">
                      <CustomRadio
                        name={'primary_address'}
                        id={'premise-address'}
                        value="PREMISE"
                        isChecked={shippingAddressSelecValue === 'PREMISE'}
                        onChange={(e) => onChangeDefaultShippingAddress('PREMISE')}
                      />
                      <label
                        className={`contact-edit__checkbox-label active-label`}
                        htmlFor={'premise-address'}
                      >
                        Primary
                      </label>
                    </Box>
                  </Box>
                )}

                {/* Mailing Address */}
                {shippingAddressOptions?.MAILING && (
                  <Box 
                    className={'contact-details-input-box address-row clickable-address'}
                    onClick={() => onChangeDefaultShippingAddress('MAILING')}
                  >
                    <Box className="contact-details-address-text single-line">
                      <Text className="address-label">Mailing Address:</Text>
                      <Text className="address-value-single-line">
                        {shippingAddressOptions.MAILING}
                      </Text>
                    </Box>
                    <Box className="contact-edit__checkbox-wrapper address-primary">
                      <CustomRadio
                        name={'primary_address'}
                        id={'mailing-address'}
                        value="MAILING"
                        isChecked={shippingAddressSelecValue === 'MAILING'}
                        onChange={(e) => onChangeDefaultShippingAddress('MAILING')}
                      />
                      <label
                        className={`contact-edit__checkbox-label active-label`}
                        htmlFor={'mailing-address'}
                      >
                        Primary
                      </label>
                    </Box>
                  </Box>
                )}
              </div>
              {/* website fields */}
              <div className="contact-details-box">
                <Box className="contact-details-title">Website:</Box>
                {contactWebsite &&
                  contactWebsite.map((website: ContactType, index: number) => (
                    <Box key={index} className={'contact-details-input-box'}>
                      <Input
                        className="contact-details-input"
                        type="text"
                        value={website.value ?? ''}
                        disabled
                        placeholder="Enter Website URL"
                      />
                      <Box className="contact-edit__checkbox-wrapper">
                        <CustomRadio
                          name={'primary_website'}
                          id={`edit-website-label-${index}`}
                          value={website.isPrimary}
                          isChecked={!!website.isPrimary as boolean}
                          onChange={(e) =>
                            handleWebURLCheckboxChange(e, index, website)
                          }
                        />
                        <label
                          className={`contact-edit__checkbox-label active-label`}
                          htmlFor={`edit-website-label-${index}`}
                        >
                          Primary
                        </label>
                      </Box>
                      <Button
                        className="license-edit__delete"
                        isDisabled={Boolean(website.isPrimary)}
                        onClick={() =>
                          onClickDeleteHandler(
                            index,
                            setContactWebsite,
                            'web_url',
                            website.value ?? '',
                            true,
                            undefined,
                            true
                          )
                        }
                      >
                        <Image
                          src={
                            website.isPrimary
                              ? '/images/ui/delete-disabled-2.svg'
                              : '/images/ui/delete-red-2.svg'
                          }
                          width="22.39px"
                          height="22.39px"
                          alt="Delete Icon"
                        />
                      </Button>
                    </Box>
                  ))}
                {addContactWebsite &&
                  addContactWebsite.map((website: ContactType, index: number) => (
                    <FormControl
                      className="form-control-box"
                      key={index}
                      isInvalid={!!website.errors}
                    >
                      <Box className={'contact-details-input-box'}>
                        <Input
                          className="contact-details-input"
                          type="text"
                          value={website.value ?? ''}
                          onChange={(e) =>
                            onChangeHandler(
                              e.target.value,
                              index,
                              'value',
                              'website'
                            )
                          }
                          onPaste={(e) => handleWebsitePaste(e, index)}
                          placeholder="Enter Website URL"
                        />

                        <Box className="contact-edit__checkbox-wrapper">
                          <CustomRadio
                            name={'primary_website'}
                            id={`edit-website-label-${index}`}
                            value={website.isPrimary}
                            isChecked={!!website.isPrimary as boolean}
                            onChange={(e) =>
                              handleWebURLCheckboxChange(
                                e,
                                index,
                                { ...website, value: website.value },
                                true
                              )
                            }
                          />
                          <label
                            className={`contact-edit__checkbox-label active-label`}
                            htmlFor={`edit-website-label-${index}`}
                          >
                            Primary
                          </label>
                        </Box>

                        <Button
                          className="license-edit__delete"
                          isDisabled={Boolean(website.isPrimary)}
                          onClick={() =>
                            onClickDeleteHandler(
                              index,
                              setAddContactWebsite,
                              'web_url',
                              website.value ?? '',
                              false,
                              'website'
                            )
                          }
                        >
                          <Image
                            src={
                              website.isPrimary
                                ? '/images/ui/delete-disabled-2.svg'
                                : '/images/ui/delete-red-2.svg'
                            }
                            width="22.39px"
                            height="22.39px"
                            alt="Delete Icon"
                          />
                        </Button>
                      </Box>
                      <ErrorMessage
                        message={
                          website.errors ??
                          handleGetError('website', index + contactWebsite.length) ??
                          null
                        }
                      />
                    </FormControl>
                  ))}

                <button
                  className="add-more-text"
                  disabled={
                    contactWebsite.length +
                    (addContactWebsite ? addContactWebsite?.length : 0) >=
                    3
                  }
                  onClick={onClickAddWebsite}
                >
                  +Add More
                </button>
              </div>
            </Box>
            )}
            {claimedData.isClaimed && isGlobalAdmin && (
              <>
               {activeTab === 'claim' && (
                <Box className={'claim-profile-controls'}>
                  <Box className='profile-claimed-status-box'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M16.6598 4.99792L7.49696 14.1608L3.33203 9.99584" stroke="#00A63E" stroke-width="1.66597" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <Box>
                      <Text className={'claimed-title'}>Profile Claimed</Text>
                      <Text className={'claimed-subtitle'}>This profile was claimed on {formattedDate}</Text>
                    </Box>
                  </Box>
                  {!showChangeOwner && !showUnclaimConfirm &&(
                  <Box className='claimed-email-address-box'>
                    <Text className={'claimed-email-label'}>Claim Email Address:</Text>
                    <Box>
                        <Box className={'claimed-email-address'}>                          
                          <Box className="email-box" style={{ position: "relative", display: "flex", alignItems: "center", gap: "6px" }}>
                                <Text className="claimed-email-value">{claimedData.email}</Text>

                                <Box onClick={handleCopy} style={{ cursor: "pointer", position: "relative", paddingTop: "2px" }}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <g clipPath="url(#clip0_17415_30213)">
                                      <path d="M13.333 5.33334H6.66634C5.92996 5.33334 5.33301 5.9303 5.33301 6.66668V13.3333C5.33301 14.0697 5.92996 14.6667 6.66634 14.6667H13.333C14.0694 14.6667 14.6663 14.0697 14.6663 13.3333V6.66668C14.6663 5.9303 14.0694 5.33334 13.333 5.33334Z" stroke="#0C1E46" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                      <path d="M2.66634 10.6667C1.93301 10.6667 1.33301 10.0667 1.33301 9.33334V2.66668C1.33301 1.93334 1.93301 1.33334 2.66634 1.33334H9.33301C10.0663 1.33334 10.6663 1.93334 10.6663 2.66668" stroke="#0C1E46" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_17415_30213">
                                        <rect width="16" height="16" fill="white"/>
                                      </clipPath>
                                    </defs>
                                  </svg>

                                  {copied && (
                                    <Box
                                      style={{
                                        position: "absolute",
                                        top: "-25px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        background: "#333",
                                        color: "#fff",
                                        fontSize: "12px",
                                        padding: "3px 8px",
                                        borderRadius: "4px",
                                        whiteSpace: "nowrap"
                                      }}
                                    >
                                      Copied
                                    </Box>
                                  )}
                                </Box>
                              </Box>

                      </Box>
                      <Text className={'claimed-email-description'}>This is the email address used to claim and log in to this profile</Text>
                    </Box>
                    <Button className={'change-owner-btn contact-modal-btn'}  onClick={() => setShowChangeOwner(true)}>Change Owner</Button>
                  </Box>
                  )}
                  {showChangeOwner && !showUnclaimConfirm && (
                  <Box className={'change-profile-owner-box'}>
                    <Text className={'change-profile-owner-label'}>Change Profile Owner</Text>
                    {hasEmails && (
                    <RadioGroup onChange={setRadioValue} value={radioValue}>
                        <Flex                         
                          align="center"
                          gap="40px"
                        >
                          <Flex align="center" gap="8px">
                            <Radio
                              id="existing-email"
                              value="existing"
                              sx={{
                                '&[data-checked]': {
                                  borderColor: '#18336E',
                                  bg: '#18336E'
                                }
                              }}
                            />
                            <label htmlFor="existing-email" style={{ cursor: "pointer" }}>
                              <Text fontSize="14px">Select from existing emails</Text>
                            </label>
                          </Flex>

                          <Flex align="center" gap="8px">
                            <Radio
                              id="new-email"
                              value="new"
                              sx={{
                                '&[data-checked]': {
                                  borderColor: '#18336E',
                                  bg: '#18336E'
                                }
                              }}
                            />
                            <label htmlFor="new-email" style={{ cursor: "pointer" }}>
                              <Text fontSize="14px">Add a new email address</Text>
                            </label>
                          </Flex>
                        </Flex>
                    </RadioGroup>
                    )}
                    {hasEmails && radioValue === "existing" && (
                        <Box className='change-profile-owner-inputs email-select-dropdown'>
                          <FormControl sx={{ paddingBottom: '8px !important' }}>
                            <FormLabel>Choose an email</FormLabel>

                            <Select placeholder="Select email"  value={selectedExistingEmail}
                                onChange={(e) => {
                                              setSelectedExistingEmail(e.target.value);
                                              setNewOwnerEmail("");
                                              setConfirmNewOwnerEmail("");
                                            }}>
                                  {contactEmail
                                      ?.filter(
                                        (email) =>
                                          email.value && email.value !== claimedData?.email
                                      )
                                      .map((email, index) => (
                                        <option key={index} value={email.value as string}>
                                          {email.value}
                                        </option>
                                      ))}
                            </Select>
                          </FormControl>
                        </Box>
                    )}
                    {(radioValue === "new" || !hasEmails) && (
                    <Box className='change-profile-owner-inputs'>
                      <Stack spacing={1}>
                        <FormControl sx={{ paddingBottom: '8px !important' }}>
                          <FormLabel>New Owner Email:</FormLabel>
                          <Input type="email" placeholder="Enter new email address"  value={newOwnerEmail}
                            onChange={(e) => {setNewOwnerEmail(e.target.value); setSelectedExistingEmail("");  setIsInvalidEmail(false);}} 
                            onBlur={() => {
                                if (newOwnerEmail && !validateEmail(newOwnerEmail)) {
                                  setIsInvalidEmail(true);
                                }
                              }}
                              onPaste={(e) => e.preventDefault()}
                            />
                            {isInvalidEmail && (
                              <Text fontSize="sm" color="red" marginLeft={"2px"} marginTop={"2px"}>
                                Invalid email
                              </Text>
                            )}
                        </FormControl>

                        <FormControl sx={{ paddingBottom: '0px !important' }}>
                          <FormLabel>Confirm New Owner Email:</FormLabel>
                          <Input type="email" placeholder="Confirm new email address"  value={confirmNewOwnerEmail}
                            onChange={(e) => {setConfirmNewOwnerEmail(e.target.value); setSelectedExistingEmail("");}} 
                            onPaste={(e) => e.preventDefault()}
                          />
                          {newOwnerEmail && confirmNewOwnerEmail &&
                              newOwnerEmail !== confirmNewOwnerEmail && (
                                <Text fontSize="sm" color="red" marginLeft={"2px"} marginTop={"2px"}>
                                  Emails do not match
                                </Text>
                              )}
                        </FormControl>
                      </Stack> 
                    </Box>
                    )}
                    {/* <Box className='update-owner-btn-wrapper'>
                      <Button className={'update-owner-btn contact-modal-btn'} >Update Owner</Button>
                      <Button className={'cancel-update-owner-btn contact-modal-btn'} onClick={() => setShowChangeOwner(false)}>Cancel</Button>
                    </Box> */}
                  </Box>
                  )}
                  {!showUnclaimConfirm &&  !showChangeOwner &&(
                    <>
                      <Box className={'unclaim-profile-box'}>
                        <Text className={'unclaim-profile-label'}>Unclaim Profile</Text>
                        {claimedData?.subscription === "premium" && (
                          <>
                          <Box className={'subscription-detected-box'}>
                          <Box sx={{paddingTop:"4px"}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path d="M9.99588 18.3257C14.5963 18.3257 18.3257 14.5963 18.3257 9.99582C18.3257 5.39536 14.5963 1.66595 9.99588 1.66595C5.39542 1.66595 1.66602 5.39536 1.66602 9.99582C1.66602 14.5963 5.39542 18.3257 9.99588 18.3257Z" stroke="#F57C00" stroke-width="1.66597" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M9.99609 6.66388V9.99582" stroke="#F57C00" stroke-width="1.66597" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M9.99609 13.3278H10.0044" stroke="#F57C00" stroke-width="1.66597" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </Box>

                          <Box>
                            <Text className={'subscription-detected-text'} marginBottom={"4px"}>Active Subscription Detected</Text>
                            <Text className={'subscription-detected-subtext'}>This profile cannot be unclaimed because it has an active subscription. Please cancel the subscription before attempting to unclaim the profile.</Text>
                          </Box>
                        </Box>
                          </>
                        )}                    
                        <Button className={'unclaim-profile-btn contact-modal-btn'} 
                        onClick={() => {
                              if (claimedData?.subscription !== "premium") {
                                setShowUnclaimConfirm(true);
                                setIsUnclaimProfile(true);
                              }
                            }}
                          sx={{
                              cursor: claimedData?.subscription === "premium" ? "not-allowed" : "pointer",
                              backgroundColor: claimedData?.subscription === "premium" ? "#D1D5DC !important" : "#E7000B",
                              color: claimedData?.subscription === "premium" ? "#6A7282 !important" : "#FFFFFF",
                            }}>                                                       
                            Unclaim Profile
                        </Button>
                          {claimedData?.subscription !== "premium" && (
                            <>
                            <Text className={'unclaim-profile-description'}>This will remove the claim from this profile, allowing it to be claimed again</Text>
                            </>
                          )}                        
                      </Box>
                    </>
                  )}
                  {showUnclaimConfirm && (
                    <>
                      <Box
                          border="1px solid #D9D9D9"
                          borderRadius="10px"
                          p="16px"
                          bg="#F9FAFB"
                          marginTop="16px"
                          width="100%"
                          className={'unclaim-profile-confirm-box'}
                        >
                          <Text fontSize="14px" fontWeight="700" color="#111113">Unclaim Profile</Text>
                            
                            <Flex align="flex-start" gap="12px" marginTop={"14px"}  border="1px solid #FFC9C9" borderRadius="10px"
                          p="12px" bg="#FEF2F2">
                                {/* Icon */}
                                <Box                                  
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  pt={"2px"}
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <g clip-path="url(#clip0_17113_2007)">
                                    <path d="M10.0003 18.3333C14.6027 18.3333 18.3337 14.6023 18.3337 9.99996C18.3337 5.39759 14.6027 1.66663 10.0003 1.66663C5.39795 1.66663 1.66699 5.39759 1.66699 9.99996C1.66699 14.6023 5.39795 18.3333 10.0003 18.3333Z" stroke="#E7000B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10 6.66663V9.99996" stroke="#E7000B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10 13.3334H10.0083" stroke="#E7000B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_17113_2007">
                                    <rect width="20" height="20" fill="white"/>
                                    </clipPath>
                                    </defs>
                                  </svg>
                                </Box>
                                <Box>
                                  <Text fontSize="14px" fontWeight="700" color="#111113">
                                    Profile Marked for Unclaim
                                  </Text>

                                  <Text fontSize="14px" color="#3F3F45">
                                    This profile will lose related benefits after saving changes. The owner will no longer have access to this profile.
                                  </Text>
                                  <Text fontSize="12px" color="#3F3F45" marginTop={"8px"}>
                                    <b>Warning:</b> This action cannot be undone. The profile
                                    will need to go through the claim process again.
                                  </Text>
                                </Box>
                            </Flex>
                           
                            
                      </Box>
                    </>
                  )}
                </Box>
                )}
            </>
            )}
            
          </ModalBody>
          <ModalFooter className={`store-contact-details-edit-footer`} sx={{paddingTop: '20px'}}>
            <Button
              colorScheme="blue"
              onClick={oncontactDetailsEditClose}
              background="#ffffff"
              color="#0C1E46"
              border="1px solid #0C1E46"
              padding="8px 11px"
              fontSize={'16px'}
              marginRight="20px"
              height={'35px'}
              width={'100px'}
              isDisabled={isCreateDealerActionInprogress}
            >
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              background="#0C1E46"
              height={'35px'}
              width={'100px'}
              fontSize={'16px'}
              padding="8px 20px"
              onClick={onSubmitHandler}
              isDisabled={getIsNotAllowedToSaveValue()}
              isLoading={isCreateDealerActionInprogress}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default StoreContactDetailsEdit;

type errorMessageType = {
  message: string | null;
};
const ErrorMessage = ({ message }: errorMessageType) => {
  return (
    <Text fontSize={'sm'} color={'tomato'}>
      {message}
    </Text>
  );
};
